// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".image-grid-section{padding:8vw 0}.image-grid-section .item{margin-bottom:32px}.image-grid-section .item a{display:block}.image-grid-section .item a img{height:auto;width:100%}.image-grid-section .item a span{display:block;font-weight:500;margin-top:12px}", ""]);
// Exports
module.exports = exports;
